import { Injectable } from '@angular/core';

import { LocationDetail } from '@cds/betting-offer';
import { GeolocationService } from '@frontend/vanilla/core';
import { first, map, shareReplay, switchMap, tap } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class UserLocationService {
    private _currentLocationId = '';

    readonly locationId$ = this.geolocationService.whenReady.pipe(
        first(),
        switchMap(() => this.geolocationService.positionChanges),
        map((v) => v.mappedLocation?.locationId ?? ''),
        tap((location) => (this._currentLocationId = location)),
        shareReplay({
            bufferSize: 1,
            refCount: false,
        }),
    );

    get currentLocationId(): string {
        return this._currentLocationId;
    }

    constructor(private geolocationService: GeolocationService) {}

    isInLocation(locations: LocationDetail[]): boolean {
        return locations.some((v: LocationDetail) => v.id.toLowerCase() === this._currentLocationId.toLowerCase());
    }
}
